<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>

  <div class="flex flex-row gap-3 ml-3 mt-3">
    <uni-field class="w-1/2" label="Manufacturer">
      <input pInputText title="Manufacturer" [ngModel]="productType.manufacturer?.name" disabled="true" />
    </uni-field>

    <uni-field class="w-1/2" label="SKU">
      <input pInputText title="SKU" [ngModel]="productType.style" disabled="true" />
    </uni-field>
  </div>

  <div class="flex flex-row gap-3 ml-3 mt-3">
    <uni-field class="w-full" label="Description">
      <input pInputText title="Description" [ngModel]="productType.description" disabled="true" />
    </uni-field>
  </div>

  <div class="flex flex-row flex-wrap ml-3 mt-3">

    <uni-field label="Change From Feature" class="w-1/2">
      <p-dropdown [options]="fromFeatures" [(ngModel)]="fromFeature"
         optionLabel="name" (onChange)="onFromFeatureChange()" />
    </uni-field>

    <uni-field label="To Feature" class="w-1/2">
      <p-dropdown [options]="toFeatures" [(ngModel)]="toFeature"
         optionLabel="name" (onChange)="onToFeatureChange()" />
    </uni-field>
  </div>


  <h6 class="ml-4 mt-6 mb-2 shrink-0">Choice Mapping</h6>

  <ng-container *ngIf="toFeature == null">
    <div class="ml-4 mr-4 mb-4 text-sm italic text-gray-500">
      Pick a target feature to see the choice mapping.
    </div>
  </ng-container>

  <ng-container *ngIf="toFeature != null && mappings.length === 0">
    <div class="ml-4 mr-4 mb-4 text-sm italic text-gray-500">
      No products of this type use a choice from '{{ fromFeature?.name }}'. Press OK to swap the feature with no per-product changes.
    </div>
  </ng-container>

  <ng-container *ngIf="toFeature != null && mappings.length > 0">
    <div class="ml-4 mr-4 mb-4 flex-1 min-h-0 flex flex-col border border-gray-300 rounded overflow-hidden">
      <table class="qb-feature-change-table qb-feature-change-header">
        <colgroup>
          <col class="qb-fc-col-from" />
          <col class="qb-fc-col-arrow" />
          <col class="qb-fc-col-to" />
        </colgroup>
        <thead>
          <tr>
            <th class="text-left">{{ fromFeature?.name }}</th>
            <th class="sr-only">Maps to</th>
            <th class="text-left">{{ toFeature?.name }}</th>
          </tr>
        </thead>
      </table>

      <div class="flex-1 min-h-0 overflow-auto">
        <table class="qb-feature-change-table qb-feature-change-body">
          <colgroup>
            <col class="qb-fc-col-from" />
            <col class="qb-fc-col-arrow" />
            <col class="qb-fc-col-to" />
          </colgroup>
          <tbody>
            <tr *ngFor="let m of mappings">
              <td class="qb-fc-from-cell">{{ m.fromFc.choiceValue }}</td>
              <td class="qb-fc-arrow-cell">&rarr;</td>
              <td class="qb-fc-to-cell">
                <p-dropdown [options]="toChoiceOptions" [(ngModel)]="m.toFc"
                            optionLabel="choiceValue" placeholder="-- pick target choice --"
                            [showClear]="true" appendTo="body" styleClass="w-full" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>

</ng-template>


<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button [disabled]="!isMappingComplete()" (click)="ok()" pButton type="button" class="p-button-raised">Ok</button>
    <button (click)="cancel()" pButton type="button" class="p-button-raised">Cancel</button>
  </div>
</ng-template>
